module.exports = __webpack_public_path__ + "img/004-visa.b1c801d3.svg";